import { createFileRoute, redirect } from '@tanstack/react-router';

import { BusinessDashboard } from '@/components/features/admin/business-dashboard/BusinessDashboard';
import { devToolsQueryOptions } from '@/hooks/use-dev-tool-toggle';
import { ErrorBoundary, ErrorFallback } from '@/modus/ErrorBoundary';
import { userHasRoles } from '@/utils/roles';

export const Route = createFileRoute('/_protected/business-dashboard')({
  beforeLoad: async ({ context }) => {
    if (!userHasRoles(context.user, ['llm-usage-dashboard-admin', 'llm-usage-dashboard-viewer'])) {
      throw redirect({ to: '/' });
    }

    const devTools = await context.queryClient.ensureQueryData(devToolsQueryOptions());
    if (!devTools.SHOW_BUSINESS_DASHBOARD) {
      throw redirect({ to: '/usage' });
    }
  },
  component: BusinessDashboardRoute,
});

function BusinessDashboardRoute() {
  return (
    <ErrorBoundary fallback={(error) => <ErrorFallback error={error} />}>
      <BusinessDashboard />
    </ErrorBoundary>
  );
}
